import { createActions, handleActions } from "redux-actions";

export const {
  conyugeCodeudorSetDni,
  conyugeCodeudorSetSexo,
  conyugeCodeudorFetchIdentidadInited,
  conyugeCodeudorFetchIdentidadCompleted,
  conyugeCodeudorFetchIdentidadFailed,
  conyugeCodeudorSetActividad,
  conyugeCodeudorSetRubro,
  conyugeCodeudorSetAntiguedad,
  conyugeCodeudorSetIngresos,
  conyugeCodeudorSetComplete,
  conyugeCodeudorClear,
  conyugeCodeudorSetPersonaSeleccionada,
} = createActions(
  "CONYUGE_CODEUDOR_SET_DNI",
  "CONYUGE_CODEUDOR_SET_SEXO",
  "CONYUGE_CODEUDOR_SET_ESTADO_CIVIL",
  "CONYUGE_CODEUDOR_FETCH_IDENTIDAD_INITED",
  "CONYUGE_CODEUDOR_FETCH_IDENTIDAD_COMPLETED",
  "CONYUGE_CODEUDOR_FETCH_IDENTIDAD_FAILED",
  "CONYUGE_CODEUDOR_SET_ACTIVIDAD",
  "CONYUGE_CODEUDOR_SET_RUBRO",
  "CONYUGE_CODEUDOR_SET_ANTIGUEDAD",
  "CONYUGE_CODEUDOR_SET_INGRESOS",
  "CONYUGE_CODEUDOR_SET_COMPLETE",
  "CONYUGE_CODEUDOR_CLEAR",
  "CONYUGE_CODEUDOR_SET_PERSONA_SELECCIONADA"
);

export const fetchIdentidad = (dni, sexo) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(conyugeCodeudorFetchIdentidadInited());
      const response = await services.api.getIdentidad(dni, sexo);
      dispatch(conyugeCodeudorFetchIdentidadCompleted(response));
    } catch (error) {
      dispatch(conyugeCodeudorFetchIdentidadFailed(error));
    }
  };
};

const initialState = {
  isLoading: false,
  error: false,
  identidadError: false,
  complete: false,
  documentoConyuge: null,
  sexoConyuge: null,
  nombreConyuge: null,
  apellidoConyuge: null,
  fechaNacimiento: null,
  cuil: null,
  actividadDeclarada: null,
  rubroEmpleoPublico: null,
  antiguedad: null,
  ingresos: 0,
  identidadPersonas: null,
  personaSeleccionada: null,
};

const AgregarConyugeCodeudorTareaReducer = handleActions(
  {
    [conyugeCodeudorSetDni]: (state, action) => {
      return {
        ...state,
        documentoConyuge: action.payload,
        complete: false,
      };
    },
    [conyugeCodeudorSetSexo]: (state, action) => {
      return {
        ...state,
        sexoConyuge: action.payload,
        complete: false,
      };
    },
    [conyugeCodeudorFetchIdentidadInited]: (state) => {
      return {
        ...state,
        isLoading: true,
        nombreConyuge: null,
        apellidoConyuge: null,
        fechaNacimiento: null,
        cuil: null,
        actividadDeclarada: null,
        rubroEmpleoPublico: null,
        antiguedad: null,
        ingresos: 0,
        complete: false,
        identidadPersonas: null,
        personaSeleccionada: null,
      };
    },
    [conyugeCodeudorFetchIdentidadCompleted]: (state, action) => {
      const response = action.payload;
      const tieneMultiplesPersonas = response.personas?.length > 1;

      let datosPersona = {};
      if (!tieneMultiplesPersonas) {
        const persona = response.personas?.[0] || response;
        datosPersona = {
          nombreConyuge: persona.nombres,
          apellidoConyuge: persona.apellido,
          fechaNacimiento: persona.fechaNacimiento,
          cuil: persona.cuil,
        };
      }

      return {
        ...state,
        isLoading: false,
        identidadError: false,
        complete: false,
        identidadPersonas: response,
        ...datosPersona,
      };
    },
    [conyugeCodeudorFetchIdentidadFailed]: (state) => {
      return {
        ...state,
        isLoading: false,
        identidadError: true,
        complete: false,
      };
    },
    [conyugeCodeudorSetPersonaSeleccionada]: (state, action) => {
      const persona = action.payload;
      return {
        ...state,
        personaSeleccionada: persona,
        nombreConyuge: persona.nombres,
        apellidoConyuge: persona.apellido,
        fechaNacimiento: persona.fechaNacimiento,
        cuil: persona.cuil,
        complete: false,
      };
    },
    [conyugeCodeudorSetActividad]: (state, action) => {
      return {
        ...state,
        actividadDeclarada: action.payload,
        rubroEmpleoPublico: null,
        antiguedad: null,
        complete: false,
      };
    },
    [conyugeCodeudorSetRubro]: (state, action) => {
      return {
        ...state,
        rubroEmpleoPublico: action.payload,
        antiguedad: null,
        complete: false,
      };
    },
    [conyugeCodeudorSetAntiguedad]: (state, action) => {
      return {
        ...state,
        antiguedad: action.payload,
        complete: false,
      };
    },
    [conyugeCodeudorSetIngresos]: (state, action) => {
      return {
        ...state,
        ingresos: action.payload,
        complete: false,
      };
    },
    [conyugeCodeudorSetComplete]: (state, action) => {
      return { ...state, complete: action.payload };
    },
    [conyugeCodeudorClear]: () => {
      return {
        ...initialState,
      };
    },
  },
  initialState
);

export default AgregarConyugeCodeudorTareaReducer;
